import "./style.scss";

import { ButtonIconPosition, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row, Spacer } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import { Button } from "@amzn/stencil-react-components/button";
import IconExternalLink from "@amzn/stencil-react-icons/icons/icon-external-link";
import React, { FC, ReactNode } from "react";
import { getString } from "../../uistringlabels/ui-string-utils";
import {
  HARDWARE_TICKET_URL,
  IT_PORTAL_URL,
  LAPTOP_SETUP_ARTICLE_URL,
} from "../../constants/external-links.constants";

const GEARS_IMAGE = "/img/hardwareSupportGears.svg";

interface SupportOptionRowProps {
  title: string;
  description: string;
  image: string;
  action: ReactNode;
}

const SupportOptionRow: FC<SupportOptionRowProps> = ({ title, description, image, action }) => (
  <Row className="flyout-row">
    <Col className="flyout-text">
      <Text fontSize="T300" fontWeight="bold">
        {title}
      </Text>
      <Spacer height="S200" />
      <Text fontSize="T200">{description}</Text>
      <Spacer height="S300" />
      {action}
    </Col>
    <img className="flyout-image" src={image} alt="" />
  </Row>
);

const ExternalLinkButton: FC<{ href: string; label: string }> = ({ href, label }) => (
  <Link href={href} target="_blank">
    <Button
      className="flyout-button"
      variant={ButtonVariant.Secondary}
      icon={<IconExternalLink aria-hidden={true} />}
      iconPosition={ButtonIconPosition.Trailing}
    >
      {label}
    </Button>
  </Link>
);

interface HardwareSupportOptionsProps {
  onOrderClick: () => void;
  isItPortalOnly?: boolean;
}

export const HardwareSupportOptions: FC<HardwareSupportOptionsProps> = ({
  onOrderClick,
  isItPortalOnly = false,
}) => {
  if (isItPortalOnly) {
    return (
      <Col gridGap="S600">
        <SupportOptionRow
          title={getString("hardwareSupport.itPortal.title")}
          description={getString("hardwareSupport.itPortal.description")}
          image={GEARS_IMAGE}
          action={
            <ExternalLinkButton
              href={IT_PORTAL_URL}
              label={getString("hardwareSupport.itPortal.button")}
            />
          }
        />
      </Col>
    );
  }

  return (
    <Col gridGap="S600">
      <SupportOptionRow
        title={getString("hardwareSupport.orderTitle")}
        description={getString("hardwareSupport.orderDescription")}
        image="/img/hardwareSupportCheckList.svg"
        action={
          <Button
            className="flyout-button"
            variant={ButtonVariant.Secondary}
            onClick={onOrderClick}
          >
            {getString("hardwareSupport.orderButton")}
          </Button>
        }
      />
      <SupportOptionRow
        title={getString("hardwareSupport.shipmentTitle")}
        description={getString("hardwareSupport.shipmentDescription")}
        image="/img/hardwareSupportBox.svg"
        action={
          <ExternalLinkButton
            href={HARDWARE_TICKET_URL}
            label={getString("hardwareSupport.shipmentButton")}
          />
        }
      />
      <SupportOptionRow
        title={getString("hardwareSupport.technicalTitle")}
        description={getString("hardwareSupport.technicalDescription")}
        image={GEARS_IMAGE}
        action={
          <ExternalLinkButton
            href={LAPTOP_SETUP_ARTICLE_URL}
            label={getString("hardwareSupport.technicalButton")}
          />
        }
      />
    </Col>
  );
};
